import { Component, OnInit, ViewChild } from '@angular/core'
import { DialogComponent } from '../../dialog/dialog.component'

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  @ViewChild('dialog') dialogRef: DialogComponent

  color = '#4bbe9c'

  constructor() { }

  ngOnInit() {
    this.dialogRef.disableCancel = true
  }

  hide () {
    return this.dialogRef.hide()
  }

  show () {
    this.dialogRef.show().then(() => this.dialogRef).catch(() => this.dialogRef)
    return this.dialogRef
  }
}
